import { gql } from "@apollo/client";

export const GET_ALL_MY_QUOTES = gql`
  query ($limit: Int, $offset: Int) {
    getMyPaginatedEstimates(limit: $limit, offset: $offset) {
      count
      data {
        id
        description
        createdAt
        status
        roomId
        hasUnreadMessage
        telephone
      }
      errors {
        message
      }
    }
  }
`;

export const GET_QUOTE_BY_ID = gql`
  query ($id: Int!) {
    getRequestedEstimate(id: $id) {
      errors {
        message
      }
      data {
        id
        description
        documents
        customer {
          firstName
          lastName
          email
        }
        roomId
        acceptedTerms
        status
        estimateResponse {
          id
          description
          documents
          expiresAt
        }
      }
    }
  }
`;

export const GET_QUOTE_BY_TOKEN = gql`
  query ($accessToken: String!) {
    getRequestedEstimateByAccessToken(accessToken: $accessToken) {
      errors {
        message
      }
      data {
        id
        description
        documents
        customer {
          firstName
          lastName
          email
        }
        roomId
        acceptedTerms
        status
        estimateResponse {
          id
          description
          documents
          expiresAt
        }
      }
    }
  }
`;
